import dayjs, { Dayjs } from 'dayjs';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

dayjs.extend(buddhistEra);

const BE_OFFSET = 543;

export class BuddhistEraAdapterDayjs extends AdapterDayjs {
  formatByString = (value: Dayjs, formatString: string): string => {
    const beFormat = formatString.replace(/YYYY/g, 'BBBB').replace(/YY/g, 'BB');
    const localeValue = this.locale ? value.locale(this.locale) : value;
    return localeValue.format(beFormat);
  };

  getYear = (value: Dayjs): number => {
    return value.year() + BE_OFFSET;
  };

  setYear = (value: Dayjs, year: number): Dayjs => {
    return value.year(year - BE_OFFSET);
  };

  parse = (value: string, format: string): Dayjs | null => {
    if (!value) return null;
    const parsed = dayjs(value, format, this.locale ?? 'en');
    if (parsed.isValid()) {
      return parsed.subtract(BE_OFFSET, 'year');
    }
    return null;
  };
}
